// extracted by mini-css-extract-plugin
export var breadcrumb = "_1f-2";
export var breadcrumbArrow = "_1f-3";
export var breadcrumbs = "_1f-0";
export var link = "_1f-4";
export var small = "_1f-1";